import * as o from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/ShoppingCart.es.js";
const r = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(p, { ref: a, ...t, weights: e }));
r.displayName = "ShoppingCartIcon";
const m = r;
export {
  m as ShoppingCart,
  r as ShoppingCartIcon
};
